<section>
    <div class="container add-member-container res-p-0">
        <div class="main-container">
            <div class="add-member-wrapper">
                <div class="header-img-infinity">
                    <img src="assets/images/add-pic-infinity.svg" alt="add-pic-infinity">
                </div>
                <div class="footer-img-heart">
                    <img src="assets/images/add-pic-heart.svg" alt="add-pic-heart">
                </div>

                <div class="about-memorial-section">
                    <div class="congratulation-wrapper">
                        <div class="confirm-img">
                            <img src="./../../../assets/images/confirmation-icon.svg" alt="confirmation-icon" />
                        </div>
                        <h1>Congratulations!</h1>
                        <p class="congrats-des">{{successData?.first_name}}’s memorial has been created successfully.


                        </p>
                        <div class="copy-link">
                            <p class="url-text">{{successData?.url}}</p>
                            <span class="ms-auto copy-img" (click)="copyUrl(successData?.url)"><img
                                    src="assets/images/icons-copy.svg" alt="copy-logo" />
                            </span>
                            <button class="btn btn-primary open-btn"
                                (click)="viewInformation(successData)">Open</button>
                        </div>
                        <span class="url-text-or">Or</span>
                        <div class="qr-code-section">
                            <div class="qr-code-header">
                                <span class="qr-image"><img
                                        [src]="successData?.qrCode?successData.qrCode:'./../../../assets/images/qr-image.png'"
                                        alt="qr-image"></span>
                                <span class="">Share or affix the code to a desired memorialized location/tombstone.<p>
                                        {{successData?.serial_number}} <span class="ms-2 copy-img cursor-pointer" (click)="copyMemoryCode(successData?.user?.serial_number)"><img
                                            src="assets/images/icons-copy.svg" alt="copy-logo" />
                                    </span></p></span>
                                        
                            </div>
                            <div class="qr-code-footer">
                                <a id="print-button" class="link-text" (click)="printCode()"><img
                                        src="assets/images/print-logo.svg" alt="print-logo" />Print Code</a>
                                <a class="link-text" (click)="downloadCode()"><img
                                        src="assets/images/download-logo.svg" alt="download-logo" />Download Code</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</section>